import { render, staticRenderFns } from "./init-todo.vue?vue&type=template&id=1b8ad068&scoped=true"
import script from "./init-todo.vue?vue&type=script&lang=js"
export * from "./init-todo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ad068",
  null
  
)

export default component.exports